export default "__VITE_ASSET__BAbL2mzI__"